// extracted by mini-css-extract-plugin
module.exports = {"logo":"sULfULwmCTzcqaNrFgPDn","divider":"_1TzAGQHYo8D0zYJox76Nqs","invite":"_27qmmzGOozjNRx8LIYngz4"};